import {Component, Inject, OnInit} from '@angular/core';
import {BlockUI, NgBlockUI} from "../../../ngx-blockui/decorators/block-ui.decorator";
import {AppService} from "../../app.service";
import {AuthService} from "../../_core/auth.service";
import {EntityService} from "../../_core/entity.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import * as _ from "lodash";

@Component({
    selector: 'app-account-dialog',
    templateUrl: './account-dialog.component.html',
    styleUrl: './account-dialog.component.scss',
    standalone: false
})
export class AccountDialogComponent implements OnInit {
	@BlockUI() blockUI: NgBlockUI;

	loading = true;
	userDetails: any = {};

	constructor(
		public appService: AppService,
		public authService: AuthService,
		public entityService: EntityService,
		public dialogRef: MatDialogRef<AccountDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }


	ngOnInit() {
		let that = this;
		this.blockUI.start();
		this.entityService.getUserInfo(true).then(response => {
			that.loading = false;
			that.userDetails = _.pick(this.appService.lUser, ['FirstName', 'LastName','Email'])
		}).catch(e => {

		}).then(o => {
			this.blockUI.stop();
		});
	}

	updateCustomer() {
		this.blockUI.start();
		let that = this;

		return this.authService.updateCustomer$(this.userDetails).subscribe(
			(response: any) => {
				this.blockUI.stop();
				if (response && response.IsSuccess) {
					that.appService.toastr('MESSAGES.saved_successfully', { type: 'success' });
					this.dialogRef.close({});
				} else {
					this.appService.alert({
						title: this.appService.translate('error_title'),
						content: this.appService.translate('error_general')
					});
				}
			},
			(err) => {
				if (err.status == '409') {
					this.appService.alert({
						title: this.appService.translate('error_title'),
						content: this.appService.translate('error_general')
					});
				} else {
					this.appService.alert({
						title: this.appService.translate('error_title'),
						content: this.appService.translate('error_general')
					});
				}
				this.blockUI.stop();
			}
		);
	}
}
